import '../App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import FlowButton from './FlowButton';

function FinishTutorialButton ({onClick, name}) {
    
    return <FlowButton className='baseElementsconfirmButton' onClick={onClick} name={name?name:"Iniziamo!"}></FlowButton>
}

export default FinishTutorialButton;